import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/device/utilization/trend30',
    name: 'deviceUtilizationTrend30Get',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
